<script setup lang="ts">
    import { CollapsibleContent } from '@/shared/ui/Collapsible';
    import { Alert } from '@/shared/ui/Alert';
</script>

<template>
    <CollapsibleContent>
        <Alert
            variant="info"
            :icon="null"
        >
            <template #description>
                <div class="text-content-primary">
                    <slot />
                </div>
            </template>
        </Alert>
    </CollapsibleContent>
</template>
